import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { loginApi, fetchTenantsApi } from '../services/api';
import fondo from '../assets/fondo.png';
import logo from '../assets/logo.png';

export default function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [tenantId, setTenantId] = useState('');
  const [tenants, setTenants] = useState([]); // [{ id, name }]
  const [tenantsLoading, setTenantsLoading] = useState(true);
  const [tenantsError, setTenantsError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  React.useEffect(() => {
    let active = true;
    (async () => {
      setTenantsLoading(true);
      setTenantsError('');
      try {
        const data = await fetchTenantsApi();
        console.log(data.value);
        if (!active) return;
        const arr = Array.isArray(data)
          ? data
          : (Array.isArray(data?.value) ? data.value : (data?.items || []));
        const mapped = arr
          .filter((t) => t && (t.id ?? t.value ?? t.code) && (t.name ?? t.descripcion))
          .map((t) => ({ id: String(t.id ?? t.value ?? t.code), name: String(t.name ?? t.descripcion) }));
        setTenants(mapped);
        if (mapped.length && !tenantId) {
          setTenantId(mapped[0].id);
        }
      } catch (err) {
        if (!active) return;
        setTenantsError('No se pudo cargar Mandatory IDs');
      } finally {
        if (active) setTenantsLoading(false);
      }
    })();
    return () => { active = false; };
  }, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const data = await loginApi({ email, password, tenantId: Number(tenantId) });
      login({
        userId: data.userId,
        tenantId: data.tenantId,
        token: data.token,
        name: data.name,
        role: data.role,
        code: data.code,
        expiresAt: data.expiresAt,
      });
      navigate('/', { replace: true });
    } catch (err) {
      setError(err.message || 'Error al iniciar sesión');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="gp-login-page" style={{
      backgroundImage: `url(${fondo})`,
    }}>
      <div className="container gp-auth-wrapper">
        <div className="row w-100 align-items-center">
          <div className="col-12 col-md-6 d-flex justify-content-md-start justify-content-center mb-4 mb-md-0">
            <img src={logo} alt="GPVigilancia" className="gpv-logo-left" />
          </div>
          <div className="col-12 col-md-6 d-flex justify-content-md-end justify-content-center">
            <div className="gp-auth-card2 p-2 p-md-3">
              
              <form onSubmit={onSubmit} noValidate>
                <div className="mb-2">
                  <label className="form-label">Email</label>
                  <div className="input-group input-group-sm">
                    <span className="input-group-text bg-white"><i className="bi bi-person-fill text-secondary"/></span>
                    <input
                      type="email"
                      className="form-control form-control-sm"
                      placeholder="usuario@grupolo.com"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>
                </div>

                <div className="mb-2">
                  <label className="form-label">Contraseña</label>
                  <div className="input-group input-group-sm">
                    <span className="input-group-text bg-white"><i className="bi bi-lock-fill text-secondary"/></span>
                    <input
                      type={showPassword ? 'text' : 'password'}
                      className="form-control form-control-sm"
                      placeholder="••••••••"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                    <button
                      type="button"
                      className="btn btn-light btn-sm border"
                      onClick={() => setShowPassword((v) => !v)}
                      aria-label={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                    >
                      <i className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`} />
                    </button>
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label">Mandatory</label>
                  <div className="input-group input-group-sm">
                    <span className="input-group-text bg-white"><i className="bi bi-building text-secondary"/></span>
                    <select
                      className="form-select form-select-sm"
                      value={tenantId}
                      onChange={(e) => setTenantId(e.target.value)}
                      required
                      disabled={tenantsLoading}
                    >
                      {tenantsLoading && <option>Cargando...</option>}
                      {!tenantsLoading && !tenants.length && <option value="">Sin datos</option>}
                      {!tenantsLoading && tenants.map((t) => (
                        <option key={t.id} value={t.id}>{t.name}</option>
                      ))}
                    </select>
                  </div>
                  {tenantsError && (
                    <div className="small text-warning mt-1">{tenantsError}</div>
                  )}
                </div>

                {error && (
                  <div className="alert alert-danger py-2" role="alert">
                    {error}
                  </div>
                )}

                <button type="submit" className="btn btn-success btn-sm w-100" disabled={loading}>
                  {loading ? 'Ingresando…' : 'Iniciar sesión'}
                </button>
                <div className="d-flex justify-content-center mt-2">
                  <span className="badge sigo-badge"><i className="bi bi-shield-check me-1"/>Acceso seguro</span>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
